import React, { lazy } from 'react';
import { Card } from '../UI/Card';
import { Button } from '../UI/Button';
import { Link } from 'react-router-dom';
export const SuccessStories = () => {
  const stories = [{
    name: 'Blackman',
    city: 'Benin',
    story: 'I attended the second edition that held in Benin city, and I was able to get a speaking gig that led on to expanding my work to Abuja.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xg79LuBq9qCVoncHNm52aL/Blackman.png'
  }, {
    name: 'Ruth',
    city: 'Lagos',
    story: 'When I started my organization, I got guidance from the curator of the networking salon, and also access to trainers for my event.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2vwTMEx2nxEJnE1zhS1xa9/Ruth.png'
  }, {
    name: 'Emmanuel',
    city: 'Abuja',
    story: "I attended Abuja's second edition of the networking salon and got a free Chiropractic adjustment that has relieved a major part of my back.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8E7j4dJFgfCndoxPHot4Vw/Emmanuel.png'
  }, {
    name: 'Shobande',
    city: 'Lagos',
    story: "Someone from our Lagos community recommended me for a grant opportunity in Lagos, and though I didn't have much time to prepare, I won the grant. I was able to use the money to improve operations of my business.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eMK3U7TENiBNQwC2kmw1Bv/Shobande.png'
  }];
  return <section className="py-16 border-b border-gray-200 bg-secondary/5" id="success-stories" data-id="element-640" data-mp="epei0q13p69f">
      <div className="container mx-auto px-4" data-id="element-641" data-mp="ipyfjupl6bw3">
        <h2 className="text-3xl font-bold mb-12 text-secondary-dark" data-id="element-642" data-mp="4qp93mr6mw5b">
          Success Stories
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-643" data-mp="9pjvszs9t4up">
          {stories.map((story, index) => <Card key={index} className="flex flex-col" data-id="element-644" data-mp="2pgognv4bf37e" data-mpi={index}>
              <div className="relative w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden shadow-md border-2 border-white" data-id="element-645" data-mp="2pjanttnangp3">
                <img src={story.image} alt={story.name} className="w-full h-full object-cover" loading="lazy" width="96" height="96" data-id="element-646" data-mp="2adoeh08by8ap" />
              </div>
              <h3 className="text-xl font-bold text-center text-primary" data-id="element-647" data-mp="26d4hpxro56p3">
                {story.name}
              </h3>
              <p className="text-secondary text-center" data-id="element-648" data-mp="21j9rebhk5th1">{story.city}</p>
              <div className="mt-4 flex-grow" data-id="element-649" data-mp="1wm00ssifnbrm">
                <p className="text-center text-secondary-dark" data-id="element-650" data-mp="1rn6rlca6i6x9">
                  "{story.story}"
                </p>
              </div>
            </Card>)}
        </div>
        <div className="mt-12 text-center" data-id="element-651" data-mp="1mqgaqmqjv7as">
          <Link to="/success-stories" data-id="element-652" data-mp="1ilyrqps0ky12">
            <Button data-id="element-653" data-mp="1in0gfx1ydj19">Read More Stories</Button>
          </Link>
        </div>
      </div>
    </section>;
};